import * as React from "react";
import { Button } from "react-ui";

interface Props {
    children?: JSX.Element | string;
    disabled: boolean;
    onClick: () => void;
}

export function AddButton(props: Props): JSX.Element {
    return (
        <Button disabled={props.disabled} use="link" onClick={props.onClick}>
            {props.children}
        </Button>
    );
}
